import React, { useCallback, useContext, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import Autocomplete from '../Autocomplete'
import { useNavigate } from 'react-router'
import { getUrlForType } from '../../utils/getUrlForEntity'
import { SearchEntity } from '@finance-lab/utils/types'
import { SearchHistory, SearchHistoryContext } from '../../contexts/SearchHistoryContext'

export const GlobalSearch = () => {
    const { t } = useTranslation()
    const navigate = useNavigate()
    const { searchHistory, addSearchHistoryEntry } = useContext(SearchHistoryContext)

    const recentHistory = useMemo(() => searchHistory.slice(0, 5), [searchHistory])

    const handleChange = useCallback(
        (option: SearchEntity | null) => {
            if (option === null) return

            const url = getUrlForType(option)

            if (url) {
                navigate(url, { replace: true })
            }
        },
        [navigate],
    )

    const handleSearchCommit = useCallback(
        (entity: SearchEntity, query: string) => {
            addSearchHistoryEntry({
                query,
                item: entity,
                date: new Date().toISOString(),
            })
        },
        [addSearchHistoryEntry],
    )

    const handleHistorySelect = useCallback(
        (record: SearchHistory) => {
            addSearchHistoryEntry({
                ...record,
                date: new Date().toISOString(),
            })
        },
        [addSearchHistoryEntry],
    )

    return (
        <Autocomplete
            openOnFocus={recentHistory.length > 0}
            onChange={handleChange}
            onSearchCommit={handleSearchCommit}
            onHistorySelect={handleHistorySelect}
            recentHistory={recentHistory}
            placeholder={t('site.nav.searchPlaceholder')}
        />
    )
}
